var React = require('react');

function Profile (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"nonzero","stroke":"currentColor","strokeLinejoin":"round","strokeWidth":"2","d":"M16.5 30C23.956 30 30 23.956 30 16.5S23.956 3 16.5 3 3 9.044 3 16.5 9.044 30 16.5 30zm0-12.913a4.696 4.696 0 1 0 0-9.391 4.696 4.696 0 0 0 0 9.391zM5.785 25.891l1.023-3.521a5.149 5.149 0 0 1 6.02-2.649c2.686.768 5.532.768 8.218 0a5.149 5.149 0 0 1 6.02 2.649l1.323 2.347"}));
}

Profile.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Profile;

Profile.default = Profile;
